import anime from 'animejs';

export const initMobileNavigation = () => {
    const mobileNavigation = document.querySelector('[data-header-nav]');
    if (!mobileNavigation) return;
    const activeClass = 'header__nav--is-open';
    const duration = 400;

    mobileNavigation.classList.contains(activeClass) ? closeMenu() : openMenu();

    function openMenu() {
        const height = mobileNavigation.scrollHeight;
        mobileNavigation.classList.add(activeClass);

        anime({
            targets: mobileNavigation,
            height: [0, height],
            easing: 'linear',
            duration: duration,
            complete: function () {
                mobileNavigation.style.height = 'auto';
            },
        });
    }

    function closeMenu() {
        const height = mobileNavigation.scrollHeight;
        mobileNavigation.style.height = `${height}px`;
        mobileNavigation.classList.remove(activeClass);

        anime({
            targets: mobileNavigation,
            height: 0,
            easing: 'linear',
            duration: duration,
        });
    }
};
